import {brand, Branded, TypeOf} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';

interface PasswordBrand {
    readonly Password: unique symbol;
}
export const Password = brand(
    NonEmptyString,
    // FIXME: implement actual password validation
    (n): n is Branded<NonEmptyString, PasswordBrand> => true,
    'Password'
);
export type Password = TypeOf<typeof Password>;
